var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import i18next from "i18next";
import styled from "styled-components";
import { BLOCK, NO_DATA_TO_DISPLAY } from "../../classConstants";
import { getClassName } from "../../helpers";
export var NoDataToDisplay = function (props) {
    return React.createElement(NoDataToDisplayDiv, { className: getClassName(NO_DATA_TO_DISPLAY, BLOCK, props.className) }, props.message || i18next.t("bookcart.no_data_to_display"));
};
var NoDataToDisplayDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-weight: bold;\n"], ["\n    font-weight: bold;\n"])));
var templateObject_1;
